export const educationData = [
    {
        id: 1,
        institution: 'Universidad Complutense de Madrid',
        course: 'Mobile developer',
        startYear: '2022',
        endYear: '2023'
    },
    {
        id: 2,
        institution: 'Henry',
        course: 'Full Stack Developer',
        startYear: '2022',
        endYear: '2022'
    },
    {
        id: 3,
        institution: 'Universidad de Buenos Aires',
        course: 'Psychology',
        startYear: '2018',
        endYear: '2021'
    },
    {
        id: 4,
        institution: 'Universidad De Oriente',
        course: 'Biochemistry',
        startYear: '2012',
        endYear: '2018'
    },
    
]